// The one spinner.
//
// Lived privately inside InstructionOverlay until the Close button
// needed the same mark (2026-08-24). Lifted rather than copied: two
// spinners drift, and this one carries its own keyframes, so a second
// copy would also mean a second @keyframes block with the same name.

interface SpinnerProps {
  /** Outer diameter in px. */
  size?: number
  /** Ring thickness. Scaled down with the diameter by default so a
   *  small spinner does not read as a solid disc. */
  thickness?: number
  /** The moving arc. Defaults to white for dark chrome. */
  color?: string
  /** The track behind it. */
  trackColor?: string
}

export function Spinner({
  size = 32,
  thickness,
  color = 'white',
  trackColor = 'rgba(255, 255, 255, 0.25)',
}: SpinnerProps = {}) {
  const border = thickness ?? Math.max(2, Math.round(size / 11))
  return (
    <div
      data-testid="spinner"
      role="progressbar"
      style={{
        boxSizing: 'border-box',
        width: size,
        height: size,
        border: `${border}px solid ${trackColor}`,
        borderTopColor: color,
        borderRadius: '50%',
        animation: 'av-spin 0.9s linear infinite',
      }}
    >
      <style>{`@keyframes av-spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}
